import { render, staticRenderFns } from "./evaluacion.vue?vue&type=template&id=1172385b"
import script from "./evaluacion.vue?vue&type=script&lang=js"
export * from "./evaluacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports